import { types } from 'mobx-state-tree';
import { CartNewProductTypeType } from '../../types/CartNewProductType';
import OrderProduct from '../order/OrderProduct';

const CartProduct = types
  .compose(
    OrderProduct,
    types.model('CartProduct', {
      added_quantity: types.maybeNull(types.number),
      bundle_id: types.maybeNull(types.string),
      cart_type: types.maybeNull(CartNewProductTypeType),
      category_name: types.maybeNull(types.string),
      ordered_quantity: types.maybeNull(types.number),
      not_valid_for_campaign_code: types.boolean,
    })
  )
  .named('CartProduct');

export default CartProduct;
